import React from 'react';
import { menuData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../variants';

const Menu = () => {
  const { title, subtitle, menuItems, sub1 } = menuData;

  return (
    <section id='menu' className='cursor-default relative h-auto min-h-[130vh] bg-menu bg-fixed bg-cover overflow-hidden pb-32 lg:pb-20'>
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-60" />

        <motion.div 
        variants={staggerContainer}
        initial='hidden'
        whileInView={'show'}
        viewport={{once: false, amount: 0.07}}
        className='relative top-24 z-10 lg:top-20'>

        <div className='container mx-auto my-8 flex flex-col items-center text-center'>

          <motion.div>
            <motion.p variants={fadeIn('down', 'tween', 0.3, 1.1)} className='pretitle'>{subtitle}</motion.p>
            <motion.h2 variants={fadeIn('down', 'tween', 0.4, 1.1)} className='h2 capitalize text-white max-w-[700px] text-center'>{title}</motion.h2>
          </motion.div>

        </div>

        <div className='relative'>
          <div className='container mx-auto'>

            <div className='min-h-[550px] z-30'>
              <motion.div 
              variants={fadeIn('left', 'spring', 0.4, 1.1)}
              className='grid grid-cols-1 lg:grid-cols-4 min-h-[450px] gap-6'>
                {menuItems.map((item, index) => {
                  const { image, name, description } = item;

                  return (
                    <div key={index}>
                      <div className='flex flex-row lg:flex-col h-full transition duration-500 ease-in-out hover:opacity-60 hover:shadow-xl cursor-pointer'>
                        <div className={'w-[45%] md:w-auto'}>
                          <img className='rounded-tl rounded-bl lg:rounded-t' src={image} alt='food' />
                        </div>

                        <div className='bg-amber-50 font-tertiary flex flex-1 flex-col justify-center px-6 lg:px-10 lg:max-h-[258px] xl:max-h-max lg:rounded-none rounded-tr rounded-br lg:rounded-b'>
                          <div className='text-center'>
                            <div className='text-xl font-semibold text-black xl:text-2xl'>{name}</div>
                            <div className='text-base'>{description}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ); 
                })}
              </motion.div>
              <motion.div
              variants={fadeIn('up', 'tween', 0.7, 1.1)} 
              className='pretitle flex text-center justify-center pt-10 lg:pt-8 font-tertiary text-2xl pb-5'>
                <p>{sub1}</p>
              </motion.div>
            </div>

          </div>
        </div>

      </motion.div>

    </section>
  );
};

export default Menu;
